import type { Device } from "@gooner/shared";
import { api } from "./api";
import { detectDeviceKind } from "./playCollection";

/**
 * Turn this tab into a screen of its own — a real device row, owned by whoever this
 * browser is signed in as, with no code involved.
 *
 * No code because there is nothing to prove: pairing exists to attach a screen that has no
 * account to a person who has one, and a signed-in tab already IS that person. The code
 * card's "Or use this device as the screen" has always worked this way; this is the same
 * call, lifted out of that button so the pending screen can make it too.
 *
 * `viewId` is what the tab is already playing, and passing it is the difference between
 * "become a screen" and "become a screen, and also change channel". A pending screen has a
 * quick setup running the whole time it waits; it should still be running a beat later
 * when the tab is a device.
 *
 * The caller navigates. Nothing here touches the router, because the two callers arrive at
 * it differently — one from a button on a browsing page, one from an effect on a screen
 * that wants `replace` so Back does not re-enter a page it has left behind.
 */
export function becomeScreen(viewId?: string): Promise<Device> {
  return api.devices
    .open({ kind: detectDeviceKind(), viewId })
    .then((r) => r.device);
}
